import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import logo from '../assets/ps.png';

import French from '../assets/pictures/france.png';
import England from '../assets/pictures/united-kingdom.png';

import '../utils/general.css';
import '../utils/navbar.css';

import frTranslations from '../locales/fr.json';
import enTranslations from '../locales/en.json';

import { useLanguage } from './languageContext'; // Importez le hook useLanguage
export default function NavBar() {
  const { language, changeLanguage } = useLanguage();

  const translations = language === 'en' ? enTranslations : frTranslations;

  return (
    <Navbar expand="lg" bg="dark" data-bs-theme="dark" fixed="top">
      <Container>
        <Navbar.Brand href="/">
          <img
            alt="ps-logo"
            src={logo}
            width="30"
            height="30"
            className="d-inline-block align-top"
          />{' '}
          Pierre Saumet
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/experiences" className='nav-font'>{translations.navbar.experiences}</Nav.Link>
            <Nav.Link href="/education" className='nav-font'>{translations.navbar.education}</Nav.Link>
            {/*
            <NavDropdown title={translations.navbar.other} id="basic-nav-dropdown" className='nav-font' disabled>
              <NavDropdown.Item disabled href="/blog" className='nav-font'>{translations.navbar.blog}</NavDropdown.Item>
              <NavDropdown.Item disabled href="/gallery" className='nav-font'>{translations.navbar.gallery}</NavDropdown.Item>
              <NavDropdown.Item disabled href="/games" className='nav-font'>{translations.navbar.games}</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item disabled href="/contact" className='nav-font'>
                {translations.navbar.contact}
              </NavDropdown.Item>
            </NavDropdown>
            */}
          </Nav>
        </Navbar.Collapse>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <NavDropdown title={translations.navbar.language} id="collapsible-nav-dropdown" className='nav-font ml-auto'>
              <NavDropdown.Item className='nav-font' onClick={() => changeLanguage('fr')}>
                <img
                  alt="French-flag"
                  src={French}
                  width="24"
                  height="24"
                />   {translations.navbar.french}
              </NavDropdown.Item>
              <NavDropdown.Item className='nav-font'onClick={() => changeLanguage('en')}>
                <img
                  alt="England-flag"
                  src={England}
                  width="24"
                  height="24"
                />   {translations.navbar.english}
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

